import {
  LENGS_LIST,
  LENGS_FILTER,
  LENGS_CREATE,
  LENGS_UPDATE,
  LENGS_UPDATE_SUCCESS,
  LENGS_CREATE_SUCCESS,
  LENGS_LIST_SUCCESS,
  LENGS_REQUEST_FAILED,
} from "../../store/lengs/actionTypes";

export const lengsList = () => {
  return {
    type: LENGS_LIST,
    payload: {},
  };
};

export const lengsCreate = (lengs) => {
  return {
    type: LENGS_CREATE,
    payload: lengs,
  };
};

export const lengsFilter = (changeUrl) => {
  return {
    type: LENGS_FILTER,
    payload: { changeUrl },
  };
};

export const lengsUpdate = (id, data) => {
  return {
    type: LENGS_UPDATE,
    payload: { id, data },
  };
};

export const lengsListSuccess = (lengs) => {
  return {
    type: LENGS_LIST_SUCCESS,
    payload: lengs,
  };
};

export const lengsCreateSuccess = (lengsCreated) => {
  return {
    type: LENGS_CREATE_SUCCESS,
    payload: lengsCreated,
  };
};

export const lengsUpdateSuccess = (lengs) => {
  return {
    type: LENGS_UPDATE_SUCCESS,
    payload: lengs,
  };
};

export const lengsRequestFailed = (error) => {
  return {
    type: LENGS_REQUEST_FAILED,
    payload: error,
  };
};
